module.exports = __webpack_public_path__ + "static/media/diners.03a0ba40.svg";